import React from 'react';

function App() {
  const value = 'Dave';
  return <div>Hello {value} <img src="img/qpr.png" alt="QPR Logo" /></div>;
}

export default App;
